import { webClient } from "@shared/apis"

const holidayApi = {
  get: (count: number) =>
    webClient.get<LastDay[]>("/holidays/business_dates", {
      params: { count },
    }),
}

export default holidayApi

interface LastDay {
  date: string
}
